// Auto-generated by sync-version.js - do not edit manually
export const VERSION = '0.15.4-alpha';
